export default function sliderForProductPageController() {
  const swiperElement = document.querySelector('.mySwiper-for-product-page');

  if (!swiperElement) {
    return;
  }

  const swiper = new Swiper('.mySwiper-for-product-page', {
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination-for-product-page',
    },
  });
}
